<template>
    <comment-editor v-model="newCommentModel" :id="id" />
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import CommentEditor from "./CommentEditor";

const {mapState, mapMutations} = createNamespacedHelpers('journeyBuilder/composer');

export default {
    name: "NewBrickComment",
    components: {
        CommentEditor
    },
    methods: {
        ...mapMutations(['setNewComment'])
    },
    computed: {
        ...mapState(['newComments']),
        newCommentModel: {
            get(){
                return this.newComments[this.brickId] || '';
            },
            set(value){
                this.setNewComment({ brickId: this.brickId, content: value });
            }
        }
    },
    props: {
        brickId: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: false
        }
    }
}
</script>
